import React from "react";
import { Link } from "react-router-dom";
import "./RulesPage.css";
const RulesPage = () => {
  return (
    <div style={{ padding: 10 }}>
      <h1 style={{ textAlign: "left" }}>RULES</h1>
      <h2>Welcome to Recite on TV RULES and Frequently Asked Questions</h2>
      <h3>READ CLOSELY – THESE ARE OFFICIAL CONTEST RULES & REGULATIONS</h3>
      <p>
        <em>Posted: 06/01/2025</em>
      </p>
      <br />
      <strong>YOU MUST HAVE YOUR PARENTS PERMISSION BEFORE UPLOADING!</strong>
      <p>
        All videos must be uploaded to
        <a href="http://www.reciteontv.com">http://www.reciteontv.com</a> by the
        18th of July to be eligible for contest.
      </p>
      <p>
        All recitation must be in Arabic and no translations can be substituted
        for Quran. Recitations are not required to be memorized for eligibility.
      </p>
      <br />
      <h3>ELIGIBILITY:</h3>
      <p>
        Contest open to legal residents of United States and Canada, ages 3
        years to 17 years at the time of entry.
      </p>
      <p>
        Void where prohibited by law. Employees, staff, suppliers or contractors
        of Guide US TV and their respective families, affiliates and
        subsidiaries, participating advertising and promotion agencies (and
        members of immediate family or friends living in the same of household
        of each such employee) are not eligible for Grand prize.
      </p>
      <br />
      <h3>PRIZES & VALUE:</h3>
      <p>
        $1,000.00 U.S. dollars will be awarded to one participant who has the
        highest score in RATINGS and is then selected by a panel of judges.
      </p>
      <p>
        Every participant is eligible but not required to win a promotional
        gift, value not to exceed $20 U.S. dollars.
      </p>
      <br />
      <h3>CONDITIONS OF PARTICIPATION:</h3>
      <p>
        No transfer, assignment, or substitution of any prize permitted by
        contestants.
        <br /> Guide US TV reserves the right to substitute prize (or prize
        component) for an item of equal or greater value at Guide US TV’s sole
        discretion.
        <br /> Nothing in these official contest rules shall obligate Guide US TV
        to publish or otherwise use any entry submitted in connection with this
        Contest.
        <br /> All federal, state and local laws and regulations apply.
        <br /> Entrants agree to be bound by the terms of these Official Rules
        and by the decisions of Guide US TV, which are final and binding on all
        matters pertaining to this Contest.
        <br />
        By entering, Entrant represents ownership or rights to convey any and
        all right and title to Guide US TV international public broadcast.
        <br /> And any video reciting’s submitted are authentic without any video
        enhancements or alterations to sound of recitation.
        <br /> NO COPYRIGHTED OR TRADEMARK PROPERTY can be used or promoted,
        without express permission from copyright or trademark holder.
      </p>{" "}
      <br />
      <h3>PARENTS TO PARTICIPATE</h3>
      <p>
        Parent or legal guardian of any Winner who has not reached age of
        majority in state wherein they live, may be required to sign and return
        Affidavit of eligibility, a Liability Release and where legally
        permissible a Publicity Release and confirmation of a license as set
        forth above within 7 days following the date of first attempted
        notification, certifying, among other things, the following: (a) entry
        does not defame or invade the privacy of any party; (b) entry does not
        infringe upon the rights of any third party; and (c) the recorded
        recitation and other materials submitted are original and have never
        been published and entry has never won an award. Failure to comply with
        this deadline may result in forfeiture of the prize and selection of an
        alternate winner.
      </p>
      <p>
        Return of any prize/prize notification as undeliverable may result in
        disqualification and selection of an alternate winner. Acceptance of the
        prize constitutes permission for Guide US TV and its agencies to use
        Winner’s name and/or likeness, biographical information, recorded
        recitation for advertising and promotional purposes without additional
        compensation, unless prohibited by law.
      </p>
      <p>
        By entering and/or accepting prize, Entrants and Winners agree to hold
        Guide US TV and its promotional partners, its directors, officers,
        employees and assigns harmless for liability, damages or claims for
        injury or loss to any person or property relating to, in whole or in
        part, directly or indirectly, participation in this Contest, the
        acceptance and/or subsequent use or misuse, or condition of any of the
        prizes awarded, or claims based on publicity rights, defamation, or
        invasion or privacy. False or deceptive entries or acts will render the
        Entrant ineligible.
      </p>
      <p>
        Guide US TV, in its sole discretion, reserves the immediate and
        unrestricted right to disqualify any entrant or prize winner, if either
        commits or has committed any act, or has been involved or becomes
        involved in any situation or occurrence which the Guide US TV deems
        likely to subject the Guide US TV, entrant or winner to ridicule,
        scandal or contempt or which reflects unfavorably upon the Guide US TV
        in any way.
      </p>
      <p>
        If such information is discovered by Guide US TV after a winner has
        received notice of his prize and before the prize is awarded, Guide US
        TV may rescind the prize in its entirety.
      </p>
      <p>
        If a portion of his/her prize has already been awarded, Guide US TV may
        withdraw the remainder of the prize that has been fulfilled. Decisions
        of the Guide US TV are final and binding in all matters related to this
        paragraph. Guide US TV is not responsible for any typographical or other
        error in the printing of the offer, administration of the contest, or in
        the announcement of the prize.
      </p>{" "}
      <br />
      <h3>6. INTERNET</h3>
      <p>
        Guide US TV is not responsible for lost or late entries nor for
        electronic transmission errors resulting in omission, interruption,
        deletion, defect, delay in operations or transmission, theft or
        destruction or unauthorized access to or alterations of entry materials,
        or for technical, network, telephone equipment, electronic, computer,
        hardware or software malfunctions or limitations of any kind, or
        inaccurate transmissions of or failure to receive entry information by
        Guide US TV or presenter on account of technical problems or traffic
        congestion on the Internet or at any Web site or any combination
        thereof.
      </p>
      <p>
        If for any reason the Internet portion of the program is not capable of
        running as planned, including infection by computer virus, bugs,
        tampering, unauthorized intervention, fraud, technical failures, or any
        other causes that corrupt or affect the administration, security,
        fairness, integrity, or proper conduct of this Contest, the Guide US TV
        reserves the right at its sole discretion, to disqualify any individual
        who tampers with the entry process, and to cancel, terminate, modify or
        suspend the Contest.
      </p>
      <p>
        Guide US TV reserves the right to select winners from eligible entries
        received as of the termination date.
      </p>
      <p>
        If there is a dispute as to the identity of the Entrant, the prize will
        be awarded to the authorized account holder of the email address. The
        “authorized account holder” is defined as the natural person to whom the
        email address is assigned.
      </p>{" "}
      <br />
      <h3>7. GOVERNING LAW:</h3>
      <p>
        This Contest is governed by the internal laws of the state of Ohio
        without regard to principals of conflict of laws. All cases and claims
        pertaining to this Contest must be brought in a court of competent
        jurisdiction in the Columbus, Ohio, without recourse to class action
        suits.
      </p>{" "}
      <br />
      <h3>8. SEVERABILITY:</h3>
      <p>
        If any provision of these Rules is found to be invalid or unenforceable
        by a court of competent jurisdiction or appointed arbitrator, such
        determination shall in no way affect the validity or enforceability of
        any other provision herein.
      </p>{" "}
      <br />
      <h3>9. WINNER NOTIFICATION:</h3>
      <p>
        All prizes will be awarded and any required Affidavit of
        Eligibility/Liability and Publicity Release (“Prize Notification
        Documents”) must be signed by winner’s parent/legal guardian on winner’s
        behalf.
        <br /> Entrants will be notified once via email with instructions for
        entrant’s parent or legal guardian to respond with the potential
        winner’s primary residence address in order to mail the Prize
        Notification Documents.
        <br /> Three (3) attempts will be made on the day after the judge’s
        decision to contact potential parents or guardians of potential winners,
        through the email address provided on the entry form, provided a correct
        email address was provided at time of sign up.
        <br />
        Potential winner will be deemed disqualified if parent or legal guardian
        does not reply within 24 hours, and an alternate winner will be selected
        based on highest RATING (number of rates and highest score). (Entrants
        and/or their parents or legal guardians are responsible for notifying
        Guide US TVs of changes in e-mail addresses.)
        <br />
        Each potential winner’s parent or legal guardian will be required to
        complete and return required documents, which must be signed and
        returned within 2 days of date printed on notification or an alternate
        winner will be selected as mentioned above.
        <br />
        Any Prize Notification Document returned as undeliverable, will result
        in disqualification, and the corresponding prize (if any) will be
        awarded to an alternate winner. Prizes cannot be substituted or
        transferred. Guide US TV reserves the right to substitute any prize with
        one of equal value, should offered prize(s) become unavailable.
        <br />
        Prizes are not redeemable for cash, except for the Grand Prize. Except
        where prohibited by law, entry and acceptance of prize constitutes
        permission to use each winner’s name, hometown, likeness, winning
        recorded recitation and prize won for advertising, promotion and/or
        publicity purposes in any and all media including online posting without
        additional compensation.
      </p>
      <p><em>Limit: one prize per entrant.</em></p>
      <br />
      <br />
      <h3>10. WINNER’S LIST:</h3>
      <p>
        Names of Winners will be shown on www.reciteontv.com in order insha
        Allah by the announcement of Eid Al Adha
      </p>{" "}
      <br />
      <h3>11. GUIDE US TV:</h3>
      <p>
        This contest, Website and all content stored upon it is copyright and
        owned completely by Guide US TV, and no unauthorized use or
        representation is allowed
      </p>
      <p>
        GUIDE US TV* and its assigns do not in any way convey any right to
        individuals or organizations to represent Guide US TV in any form
        regarding this or any other contest or publicity or promotional
        activity.
      </p>
      <p>
        CAUTION: ANY ATTEMPT BY A CONTESTANT, ORGANIZATION, OR GROUP TO
        DELIBERATELY DAMAGE ANY WEB SITE OR UNDERMINE THE LEGITIMATE OPERATION
        OF THIS CONTEST IN ANY WAY, IS A VIOLATION OF CRIMINAL AND CIVIL LAWS
        AND SHOULD SUCH AN ATTEMPT BE MADE, GUIDE US TV RESERVES THE RIGHT TO
        SEEK DAMAGES FROM ANY SUCH CONTESTANT TO THE FULLEST EXTENT OF THE LAW.
      </p>{" "}
      <br />
      <section className="button-submit">
        <Link to="/Login" className="button1">
          Accept
        </Link>
        <br />

        <br />
        <Link to="/watch/" className="button1">
          Decline
        </Link>
      </section>
    </div>
  );
};
export default RulesPage;
